import React from 'react';

const Bg = (props) => {
  return (
    <div className="bg" {...props}>
      <video loop autoPlay muted playsInline className="bg-video animated fadeIn">
        <source src={props.bg ? props.bg : '/img/olivestone/olive_clip.mp4'} type="video/mp4" />
      </video>
    </div>
  );
};

export default Bg;
